<template>
  <b-row>
    <b-col cols="12">
      <karma-program-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaProgramAddForm from './KarmaProgramAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaProgramAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
